"use strict";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dismissedWarningTokensSelector } from "features/tokens/slice/selectors";
import { dismissTokenWarning } from "features/tokens/slice/slice";
import { isBasicTokenInfo } from "features/tokens/slice/types";
import { getValidAddress } from "utils/addresses";
import { serializeToken } from "utils/currency";
export function useDismissedTokenWarnings(info) {
  const dispatch = useDispatch();
  const dismissedTokens = useSelector(dismissedWarningTokensSelector);
  const isBasicInfo = isBasicTokenInfo(info);
  const lowercasedAddress = getValidAddress(
    isBasicInfo ? info.address : info?.isToken ? info?.address : void 0,
    false
  );
  const tokenWarningDismissed = Boolean(
    info && lowercasedAddress && dismissedTokens && dismissedTokens[info.chainId]?.[lowercasedAddress]
  );
  const onDismissTokenWarning = useCallback(() => {
    if (isBasicInfo) {
      dispatch(dismissTokenWarning({ token: info }));
    } else {
      if (info?.isToken) {
        dispatch(dismissTokenWarning({ token: serializeToken(info) }));
      }
    }
  }, [isBasicInfo, info, dispatch]);
  return { tokenWarningDismissed, onDismissTokenWarning };
}
